import { render, staticRenderFns } from "./VcLogo.vue?vue&type=template&id=3a9d626e"
import script from "./VcLogo.vue?vue&type=script&lang=js"
export * from "./VcLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports